import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { DffSideModule } from "@dffedb/ui";

import { DefaultComponent } from "./default.component";

@NgModule({
    imports: [CommonModule, DffSideModule, DefaultComponent],
    exports: [],
    providers: []
})
export class EForsyningFeaturesDefaultModule {}
